import { KeyboardArrowDown } from "@mui/icons-material";
import { Popover, Stack, Typography, Button } from "@mui/material";
import { useMenuState } from "hooks/useMenuState";
import { makeStyles } from "components/providers/makeStyles";

const useStyles = makeStyles(theme => ({
    button: {
        border: 0,
        padding: theme.spacing(1),
        textAlign: "left",
        backgroundColor: theme.palette.background.paper,
        "&:hover": {
            backgroundColor: theme.palette.background.low,
        },
        "&:active": {
            backgroundColor: theme.palette.background.low,
            outline: `1px solid ${theme.palette.border.main}`,
        },
        "&:focus-visible": {
            backgroundColor: theme.palette.background.low,
            outline: `3px solid ${theme.palette.border.focus}`,
            borderRadius: "10px",
            outlineOffset: "2px",
        },
        "&.Mui-selected": {
            backgroundColor: theme.palette.background.low,
            outline: `1px solid ${theme.palette.border.main}`,
        },
        "&:disabled": {
            opacity: 0.6,
            backgroundColor: theme.palette.secondary.light,
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: theme.palette.state.tapDark,
        },
    },
    stack: {
        alignItems: "flex-start",
    },
    subTitle: {
        color: theme.palette.text.secondary,
        textTransform: "uppercase",
    },
    flexStack: {
        color: theme.palette.text.secondary,
    },
    title: {
        color: theme.palette.text.primary,
    },
    menu: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2),
        boxShadow: theme.shadows.custom[3],
    },
    heading: {
        color: theme.palette.text.secondary,
    }
}));

export const ButtonWithMenu = ({ title, subtitle, heading, children, minWidth = 275 }) => {
    const [anchorEl, openMenu, closeMenu] = useMenuState();
    const classes = useStyles();

    return (
        <>
            <Button className={`${classes.button} ${!!anchorEl ? "Mui-selected" : ""}`} onClick={openMenu}>
                <Stack className={classes.stack} spacing={1}>
                    <Typography className={classes.subTitle} variant="label2">{subtitle}</Typography>
                    <Stack className={classes.flexStack} direction="row" spacing={1}>
                        <Typography className={classes.title} variant="h7">{title}</Typography>
                        <KeyboardArrowDown color="inherit" />
                    </Stack>
                </Stack>
            </Button>

            <Popover
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={closeMenu}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}>
                <Stack className={classes.menu} spacing={2} minWidth={minWidth}>
                    {heading && <Typography className={classes.heading} variant="label1">{heading}</Typography>}
                    {children}
                </Stack>
            </Popover>
        </>
    );
};
